<template>
  <div>
    <a-form-model :rules="rules" ref="ruleForm" :model="form" :label-col="labelCol"
                  :wrapper-col="wrapperCol">
      <a-form-model-item label="优惠券占位符">
        #{coupon}
      </a-form-model-item>
      <a-form-model-item :label="$t('message.txtManagement.tableTitle2')" prop="content_name">
        <a-input :size="$globalSize" v-model="form.content_name" :placeholder="$t('message.txtManagement.tableTitle2')"/>
      </a-form-model-item>
      <a-form-model-item label="文案标签" prop="content_tag_ids">
        <a-tree-select :size="$globalSize" show-search style="width: 100%" tree-checkable :maxTagCount="3" 
                       :replaceFields="{ children: 'children', title: 'title', key: 'id', value: 'id' }"
                       :tree-data="labelTreeData" v-model="form.content_tag_ids"
                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                       :placeholder="$t('message.txtManagement.AddFormTitle8')" allow-clear
                       tree-default-expand-all
                       treeNodeFilterProp="title">
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="content_type">
        <a-select :size="$globalSize" style="width: 200px" v-model="form.content_type">
          <a-select-option value='推文'>
            推文
          </a-select-option>
          <a-select-option value='模板消息'>
            模板消息
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <template v-if="form.content_type === '推文'">
        <a-form-model-item label="文案标题">
          <a-input :size="$globalSize" v-model="form.app_push_content_target_name" placeholder="请输入文案标题"/>
        </a-form-model-item>
        <a-form-model-item  label="" :wrapper-col="{span:24}">
          <div class="card-container">
            <a-tabs type="card" v-model="attachmentsKey">
              <a-tab-pane key="text" tab="文本">
                <div style="position: relative">
                  <!-- <a-button  :size="$globalSize" 
                      style="width: 120px;margin-bottom: 10px;position: absolute;bottom:5px;right: 10px;z-index: 2;border-radius: 8px;color: #bbbbbb"
                      @click="$refs.selectTextModalRef.showModal()">
                    <a-icon type="plus"></a-icon>
                    文案库选择
                  </a-button> -->
                  <a-textarea :size="$globalSize" v-model="form.content_detail" :rows="6" style="resize: none"/>
                </div>
              </a-tab-pane>
              <a-tab-pane key="image" tab="图片">
              </a-tab-pane>
              <a-tab-pane key="mpvideo" tab="视频">
              </a-tab-pane>
              <a-tab-pane key="mpnews" tab="图文消息">
              </a-tab-pane>
            </a-tabs>
            <div class="appendix" v-if="attachmentsKey === 'image' || attachmentsKey === 'mpvideo'">
              <div class="preview-box" v-for="item in form.attachments" @mouseenter="item.showDelete = true"
                   @mouseleave="item.showDelete = false">
                <img v-if="item.type === 'image'" :src="item.url" alt="">
                <!--            <video v-if="item.type === 'video'" :src="item.url" controls="controls"-->
                <!--                   style="width: 100%;height: 100%;object-fit: cover;"></video>-->

                <a-icon v-if="item.type==='mpvideo'" class="icon48" type="play-square"></a-icon>
                <div class="preview-name">
                  {{ item.name }}
                </div>
                <div
                    class="preview-delete"
                    v-if="item.showDelete">
                  <a-tooltip title="删除">
                    <a-icon type="delete" style="cursor: pointer" @click="deleteItem(item)"></a-icon>
                  </a-tooltip>
                </div>
              </div>
              <div @click.self="showMenu" class="upload-box"
                   v-if="form.attachments.length < 1">
                <a-icon v-if="!uploadLoading" type="plus" class="upload-icon" @click="showMenu"></a-icon>
                <a-icon v-else type="loading" class="upload-icon"></a-icon>
                <a-menu
                    :style="{position: 'absolute',top:menuPos.y+'px',left:menuPos.x+'px',border:'1px solid #ccc',boxShadow:'1px 1px #ccc',zIndex:999999}"
                    v-if="menuVisible">
                  <a-menu-item @click="uploadLocal()">
                    本地选择
                  </a-menu-item>
                  <a-menu-item @click="$refs.uploadImgRef.showModalTest(this.attachmentsKey)">
                    素材库选择
                  </a-menu-item>
                </a-menu>
              </div>
            </div>
            <div v-if="attachmentsKey === 'mpnews'">
              <a-card :bordered="false" style="width: 200px;text-align: center;cursor: pointer" @click="$refs.graphicMessageModalRef.showModal()">
                <a-icon type="folder" style="cursor: pointer;font-size: 24px;" ></a-icon>
                <p style="color: var(--main-color)">从素材库选择</p>
              </a-card>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="跳转链接">
          <a-input :size="$globalSize" v-model="form.content_link" placeholder="请输入跳转链接"/>
        </a-form-model-item>
      </template>

      <div v-else>
        <a-form-model-item label="小程序">
          <a-select :size="$globalSize" v-model="form.wechatOA_info.microAppObj" style="width: 200px" label-in-value>
            <a-select-option v-for="item in miniProgList" :value="item.appId" :key="item.appId">
              {{ item.appName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="跳转路径" prop="page_path">
          <a-input :size="$globalSize" v-model="form.page_path" placeholder="请输入跳转路径"/>
        </a-form-model-item>
        <a-form-model-item label="模板选择" prop="wechatOATemplate">
          <a-select :size="$globalSize" style="width: 200px" v-model="form.wechatOA_info.wechatOATemplate">
            <a-select-option v-for="item in wechatOATemplateList" :value='item.template_id' :key="item.template_id">
              {{ item.title }}
            </a-select-option>

          </a-select>
        </a-form-model-item>
        <a-form-model-item label="URL" prop="url">
          <a-input :size="$globalSize" v-model="form.url" placeholder="请输入URL"/>
        </a-form-model-item>
      </div>
    </a-form-model>
    <graphic-message-modal ref="graphicMessageModalRef" @sync="syncGraphicMessageModal"></graphic-message-modal>
    <text-library-select-modal ref="selectTextModalRef" @changeCopyWrite="syncText"></text-library-select-modal>
    <a-upload
        :accept="uploadAccept"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :before-upload="beforeUpload"
        @change="handleChange"
        style="display: none"
    >
      <a-button  :size="$globalSize"  type="primary" icon="upload" ref="uploadBtnRef" ></a-button>

    </a-upload>
    <upload-img
        ref="uploadImgRef"
        v-model="materialImg"
        :multiple="false"
        :show-preview="false"
        @initStep="()=>{}"
        @attachmentsChange="()=>{}">

    </upload-img>
  </div>
</template>

<script>
import utils from "@/utils";
import textLibrarySelectModal from "@/views/material/components/textLibrarySelectModal";
import materialUpload from "@/interface/pages/material/materialUpload";
import moment from "moment";
import uploadImg from "@/views/material/components/uploadImg";
import graphicMessageModal from "@/views/material/components/graphicMessageModal";
export default {
  name: "wechatoaPushTemp",
  components: {
    textLibrarySelectModal,
    uploadImg,
    graphicMessageModal
  },
  inject: {
    parent: {
      from: 'parent'
    },
    changePreviewItem: {
      from: 'changePreviewItem',
      default: () => {
      }
    }
  },
  data() {
    return {
      materialImg: '',
      attachmentsKey: 'text',
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 5
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 16
      },
      form: {
        content_name: '',
        content_tag_ids: [],
        content_detail: '',
        content_type: '推文',
        attachments: [],
        wechatOA_info:{
          microAppObj: {},
          wechatOATemplate: '',
          page_path: '',
          url: ''
        },
        app_push_content_target_name:'',
        content_link:''
      },
      labelTreeData: this.parent.labelTreeData,
      rules: {
        content_name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        content_detail: [{required: true, message: this.$t('message.strategyStore.pleaseEnterContent'), trigger: 'blur'}],
      },
      menuVisible: false,
      menuPos: {
        x: 0,
        y: 0
      },
      uploadLoading: false,
      uploadAccept: '*',
      miniProgList: [],
      wechatOATemplateList: []
    }
  },
  watch: {
    form: {
      handler(v) {
        this.changePreviewItem && this.changePreviewItem({
          type: 'WechatOA',
          detail: v.content_detail,
          attachments: v.attachments
        })
      },
      deep: true,
      immediate: true
    },
    materialImg: {
      handler(v) {
        this.addItem({
          url: v.url,
          name: v.name,
          type: 'image',
          material: {...v}
        })
      },
      deep: true
    },
    attachmentsKey: {
      handler(nv, ov) {
        if (nv === 'text' || ov === 'text') {
          return
        }
        this.form.attachments = []
      }
    }
  },
  methods: {
    async getWechatOATemplateList() {
      const {data: res} = await materialUpload.getWechatOATemplateList(this, {})
      try {
        if (res.code === '200') {
          this.wechatOATemplateList = res.data
          if (res.data.length) {
            this.form.wechatOA_info.wechatOATemplate = res.data[0].template_id
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getWeChatMiniProgramName() {
      const {data: res} = await materialUpload.getWeChatMiniProgramName(this, {})
      try {
        if (res.code === '200') {
          this.miniProgList = res.data
          if (res.data.length) {
            this.form.wechatOA_info.microAppObj = res.data[0]
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    },
    syncGraphicMessageModal(record){
      this.form.attachments.push(record)
    },
    uploadLocal() {
      switch (this.attachmentsKey) {
        case 'image':
          this.uploadAccept = 'image/gif,image/jpeg,image/jpg,image/png'
          break;
        case 'mpvideo':
          this.uploadAccept = 'video/*'
          break;
      }
      setTimeout(() => {
        this.$refs.uploadBtnRef.$el.click()
      }, 0)
    },
    syncText(v) {
      this.form.content_detail = v
    },
    async formValidate() {
      let data
      await this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        const wechatTmp = this.wechatOATemplateList.find(i=>i.template_id === this.form.wechatOA_info.wechatOATemplate)
        let wechatOA_info = {}
            if(this.form.content_type === '模板消息'){
              wechatOA_info= {
                mini_program_name: this.form.wechatOA_info.microAppObj.label.trim(),
                mini_program_appid: this.form.wechatOA_info.microAppObj.key,
                template_id: this.form.wechatOA_info.wechatOATemplate,
                template_content: wechatTmp.content,
                template_title:wechatTmp.title
              }
            }

        data = {
          ...this.form,
          wechatOA_info
        }
      })
      return {...data}
    },
    deleteItem(item) {
      this.form.attachments = this.form.attachments.filter(i => i.id !== item.id)
    },
    showMenu(e) {
      this.menuPos.x = e.layerX
      this.menuPos.y = e.layerY
      this.menuVisible = true
    },
    hideMenu(e) {
      if (e.target.className !== 'upload-box') {
        this.menuVisible = false
      }
    },
    beforeUpload() {
      return false;
    },
    handleChange(info) {
      this.uploadAttachments(info.file);
    },
    addItem(item) {
      this.form.attachments.push({id: moment().valueOf(), showDelete: false, ...item})
    },
    async uploadAttachments(file) {
      this.uploadLoading = true
      const {data: res} = await materialUpload.uploadAttachments(this, {
        data: {
          file_data: file,
        },
      });
      if (res.code === "200") {
        this.addItem({
          type: this.attachmentsKey,
          url: res.data,
          name: file.name,
          size: this.renderSize(file.size)
        })
        this.$message.success('上传成功');
      } else {
        this.$message.error(res.message);
      }
      this.uploadLoading = false
    },
    renderSize(filesize) {
      if (null == filesize || filesize == '') {
        return "0 B";
      }
      let unitArr = new Array("B", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb");
      let index = 0;
      let srcsize = parseFloat(filesize);
      index = Math.floor(Math.log(srcsize) / Math.log(1024));
      let size = srcsize / Math.pow(1024, index);
      size = size.toFixed(2);//保留的小数位数
      return size + ' ' + unitArr[index];
    },
  },
  mounted() {
    window.addEventListener('click', this.hideMenu)
    utils.languageChange(this, {labelCol: 8, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
    if (this.parent.currentItem) {
      this.form = {
        ...this.parent.currentItem,
        content_tag_ids: this.parent.currentItem.content_tag_ids ? this.parent.currentItem.content_tag_ids.split(',') : []
      }
    }
    this.getWeChatMiniProgramName()
    this.getWechatOATemplateList()
  },
  beforeDestroy() {
    window.removeEventListener('click', this.hideMenu)
  }
}
</script>

<style scoped lang="less">
.card-container {
  background: #f5f5f5;
  //overflow: hidden;
  padding: 24px;
  width: 100%
}

.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 300px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.appendix {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  grid-gap: 10px;

  .preview-box, .upload-box {
    width: calc((100% - 10px) / 2);
    min-width: calc((100% - 10px) / 2);
    max-width: calc((100% - 10px));
    height: 100px;
    border: 1px solid #000;
    position: relative;
  }

  .preview-box {
    //margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border: 1px solid #ccc;

    img {
      max-width: 100%;
      max-height: 100%;
    }

    .icon48 {
      font-size: 48px;
    }

    .preview-name {
      width: 100%;
      height: 20px;
      font-size: 14px;
      position: absolute;
      bottom: 0;
      margin: 0;
      padding: 0 5px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: 20px;
    }

    .preview-delete {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.65);
      line-height: 100px;
      color: white;
      text-align: center
    }
  }

  .upload-box {
    text-align: center;
    line-height: 120px;
    cursor: pointer;
    overflow: unset;
    border: 1px solid #ccc;
    color: #ccc;

    .upload-icon {
      font-size: 50px;
    }
  }
}
</style>
